import Rows from "PFApp/components/table/rows";
import { TableColumn } from "PFApp/components/table/table_types";
import { DropdownOption } from "PFComponents/dropdown/dropdown";
import NoBackdropDropdownButton from "PFComponents/dropdown/no_backdrop_dropdown_button";
import { SkillsFrameworksResponse } from "PFCore/services/admin/skills_frameworks/fetch_skills_frameworks";
import DotsIcon from "PFIcons/vertical_dots.svg";
import React, { useCallback, useMemo } from "react";

import { SkillsFrameworkData } from "../../skills_frameworks.types";
import { getFormattedSkillsFramework } from "../../utils";
import css from "./skills_frameworks_table.module.scss";
import { useSkillsFrameworksCellRenderer } from "./use_skills_frameworks_cell_renderer";

type SkillsFrameworksRowsProps = {
  actions: DropdownOption[];
  skillsFrameworks: SkillsFrameworksResponse;
  columns: TableColumn[];
  isLoading?: boolean;
};

export const SkillsFrameworksRows = ({
  actions,
  skillsFrameworks,
  columns,
  isLoading
}: SkillsFrameworksRowsProps) => {
  const renderCell = useSkillsFrameworksCellRenderer();

  const skillsFrameworksEntries = useMemo<SkillsFrameworkData[]>(
    () => skillsFrameworks.entries.map((framework) => getFormattedSkillsFramework(framework)),
    [skillsFrameworks]
  );

  const renderActions = useCallback(
    (item) => (
      <NoBackdropDropdownButton
        style={{ marginLeft: "auto" }}
        options={actions}
        buttonKind="blank"
        buttonStyle={{ height: 18 }}
        dropDownStyle={{ maxHeight: 230 }}
        handleClick={(event) => event.preventDefault()}
        handleChange={(optionItem) => (optionItem.func ? optionItem.func(item) : optionItem(item))}
        qaId={`SkillsFrameworksListPageRowMoreButton.${item.id}`}
      >
        <DotsIcon width={20} height={17} />
      </NoBackdropDropdownButton>
    ),
    [actions]
  );

  return (
    <Rows
      className={css.skillsRow}
      items={skillsFrameworksEntries}
      columns={columns}
      isLoading={isLoading}
      renderCell={renderCell}
      renderActions={renderActions}
      classes={{ mediumColumn: css.mediumColumn }}
    />
  );
};
